var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language"},[_c('h4',[_vm._v(_vm._s(_vm.$t("menu.language")))]),_c('label',{on:{"click":_vm.switchToFr}},[_vm._v("fr")]),_vm._v(" | "),_c('label',{on:{"click":_vm.switchToEn}},[_vm._v("en")])])
}
var staticRenderFns = []

export { render, staticRenderFns }